 <template>
    <el-select
        @change="SelectChange"
        v-model="selectValue"
        size="mini"
        :style="{ width: width, margin: margin }"
        :placeholder="placeholder"
        :clearable="clearable"
        :filterable="filterable"
        :multiple="multiple" >
        <el-option v-for="(item, idx) in select" :key="idx" :label="item.label" :value="item.value">
            <span :style="{ float: 'left', color: item.color }"><i class="fa fa-circle"></i></span>
            <span style="float: right; color: #8492a6; font-size: 12px">{{ item.label }}</span>
        </el-option>
    </el-select>
</template>
<script>
export default {
    props: {
        value: {
            type: [Number, String, Array],
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        filterable: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '100%'
        },
        margin: {
            type: String,
            default: '0px'
        },
        placeholder: {
            type: String,
            default: '重要程度'
        },
    },
    watch: {
        value () {
            this.selectValue = this.value
        }
    },
    data () {
        return {
            select: [
                { value: 4, label: '次要【P4】', color: '#4caf50' },
                { value: 3, label: '一般【P3】', color: '#2196f3' },
                { value: 2, label: '重要【P2】', color: '#ff9800' },
                { value: 1, label: '非常重要【P1】', color: '#f44336' },
            ],
            selectValue: null,
        }
    },
    mounted () {
        this.selectValue = this.value
    },
    methods: {
        SelectChange(data) {
            this.$emit('input', data)
            this.$emit('onChange', data)
        }
    }
}
</script>